import React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';

import { OEText } from '../../atoms';
import { flex, mr } from '../../style-utils';
import { ProgressBar, ProgressBarProps } from '../progress-bar/progress-bar';

export interface ProgressBarWithCounterProps
  extends Omit<ProgressBarProps, 'percentage'> {
  current: number;
  total: number;
  offsetByOne?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  progressBarCurrent?: number;
}

export function ProgressBarWithCounter({
  current = 0,
  total = 0,
  offsetByOne = false,
  containerStyle,
  progressBarCurrent,
  style,
  ...rest
}: ProgressBarWithCounterProps) {
  return (
    <View style={[flex('flex-row', 'align-items-center'), containerStyle]}>
      <ProgressBar
        percentage={
          (progressBarCurrent === undefined ? current : progressBarCurrent) /
          total
        }
        style={[mr(10), style]}
        {...rest}
      />
      <OEText>
        {current + (offsetByOne ? 1 : 0)} / {total}
      </OEText>
    </View>
  );
}
